module.exports = " <div class=first-read-packet-modal v-if=show _v-3e65b337=\"\"> <div class=shadow _v-3e65b337=\"\"></div> <div class=content _v-3e65b337=\"\"> <div class=bg2 _v-3e65b337=\"\"> <div class=amount _v-3e65b337=\"\">{{amount}}</div> </div> <div class=bg1 _v-3e65b337=\"\"> <div class=btn @click=goToFirst _v-3e65b337=\"\">领取红包</div> </div> <div class=close @click=close _v-3e65b337=\"\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3e65b337!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirstRedPacketModal.vue
// module id = 408
// module chunks = 31